import { IconProps } from './types';

export const CreateIcon = (props: IconProps) => (
  <svg viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_980_44)'>
      <path
        d='M5.78711 1V10.573'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        {...props}
      />
      <path
        d='M1 5.78711H10.573'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        {...props}
      />
    </g>
  </svg>
);
